import Component from 'flarum/common/Component';
/**
 * Dropdown de ordenação visualmente alinhado ao tema Avocado:
 * trigger pill com chevron, painel suspenso com check no item ativo,
 * close-on-outside-click. Não depende do avocado estar instalado —
 * copiamos a estrutura e estilizamos via classes MpShop-sort* nas
 * tokens do design system do marketplace.
 */
export default class MpSortDropdown extends Component {
  open = false;
  rootEl = null;
  outsideHandler = null;
  oncreate(vnode) {
    super.oncreate(vnode);
    this.rootEl = vnode.dom;
    this.outsideHandler = e => {
      if (!this.open) return;
      if (this.rootEl && !this.rootEl.contains(e.target)) {
        this.open = false;
        m.redraw();
      }
    };
    document.addEventListener('mousedown', this.outsideHandler);
  }
  onremove(vnode) {
    super.onremove(vnode);
    if (this.outsideHandler) {
      document.removeEventListener('mousedown', this.outsideHandler);
      this.outsideHandler = null;
    }
  }
  view() {
    const {
      options,
      currentKey,
      onChange,
      minWidth
    } = this.attrs;
    const current = options.find(o => o.key === currentKey) || options[0];
    const label = current?.label ?? currentKey;
    return m("div", {
      className: "MpShop-sortWrap"
    }, m("button", {
      type: "button",
      className: `MpShop-sortTrigger${this.open ? ' is-open' : ''}`,
      onclick: () => {
        this.open = !this.open;
        m.redraw();
      },
      "aria-haspopup": "listbox",
      "aria-expanded": this.open
    }, label, m("i", {
      className: `fas fa-chevron-${this.open ? 'up' : 'down'}`,
      "aria-hidden": "true"
    })), this.open && m("div", {
      className: "MpShop-sortDropdown",
      role: "listbox",
      style: minWidth ? {
        minWidth: `${minWidth}px`
      } : undefined
    }, options.map(option => {
      const isActive = currentKey === option.key;
      return m("button", {
        type: "button",
        key: option.key,
        role: "option",
        "aria-selected": isActive,
        className: `MpShop-sortOption${isActive ? ' is-active' : ''}`,
        onclick: () => {
          this.open = false;
          onChange(option.key);
        }
      }, m("span", {
        className: "MpShop-sortOption-check"
      }, isActive && m("i", {
        className: "fas fa-check",
        "aria-hidden": "true"
      })), option.label);
    })));
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/MpSortDropdown', MpSortDropdown);